import React, { useState } from 'react';
import { useVideo } from '../../../contexts/VideoContext';
import './Steps.css';

const Step5Review = () => {
  const { videoData, prevStep, nextStep } = useVideo();
  const [error, setError] = useState('');

  const getEmotionLabel = (emotion) => {
    const emotions = {
      happy: '😊 Happy',
      excited: '🤩 Excited',
      playful: '😄 Playful',
      tired: '😴 Tired',
      silly: '🤪 Silly',
      relaxed: '😌 Relaxed',
      curious: '🤔 Curious',
      proud: '😎 Proud',
    };
    return emotions[emotion] || emotion;
  };

  const getActivityLabel = (activity) => {
    const activities = {
      playing: '🎾 Playing',
      socializing: '🐕 Socializing',
      training: '🎓 Training',
      napping: '😴 Napping',
      eating: '🍖 Eating',
      walking: '🚶 Walking',
      swimming: '🏊 Swimming',
      running: '🏃 Running',
      cuddling: '🤗 Cuddling',
      exploring: '🔍 Exploring',
    };
    return activities[activity] || activity;
  };

  const handleSubmit = () => {
    // Validate that we have either a photo or breed
    if (!videoData.useBreedLibrary && !videoData.photoUrl) {
      setError('Please go back to Step 2 and upload a photo or select a breed');
      return;
    }

    if (videoData.useBreedLibrary && !videoData.selectedBreed) {
      setError('Please go back to Step 2 and select a breed');
      return;
    }

    // Everything looks good, proceed to payment step
    nextStep();
  };

  return (
    <div className="wizard-step">
      <div className="step-content">
        <div className="step-icon">✨</div>
        <h2 className="step-title">Review Your Video</h2>
        <p className="step-description">
          Everything looks good? Let's create your video!
        </p>

        <div className="review-card">
          {/* Pet Name */}
          <div className="review-item">
            <h3 className="review-label">Pet's Name</h3>
            <p className="review-value">{videoData.petName}</p>
          </div>

          {/* Photo/Breed */}
          <div className="review-item">
            <h3 className="review-label">Photo</h3>
            {videoData.useBreedLibrary ? (
              videoData.selectedBreed ? (
                <p className="review-value">🐕 {videoData.selectedBreed}</p>
              ) : (
                <p className="review-value" style={{ color: '#FF6B6B' }}>
                  ⚠️ No breed selected - please go back to Step 2
                </p>
              )
            ) : videoData.photoUrl ? (
              <img
                src={videoData.photoUrl}
                alt="Pet"
                className="review-photo"
              />
            ) : (
              <p className="review-value" style={{ color: '#FF6B6B' }}>
                ⚠️ No photo uploaded - please go back to Step 2
              </p>
            )}
          </div>

          {/* Emotion */}
          <div className="review-item">
            <h3 className="review-label">Emotion</h3>
            <p className="review-value">{getEmotionLabel(videoData.emotion)}</p>
          </div>

          {/* Activities */}
          <div className="review-item">
            <h3 className="review-label">Activities</h3>
            <div className="review-activities">
              {videoData.activities.map((activity) => (
                <span key={activity} className="activity-tag">
                  {getActivityLabel(activity)}
                </span>
              ))}
            </div>
          </div>
        </div>

        {error && <div className="error-message">{error}</div>}

        {/* Navigation */}
        <div className="step-navigation">
          <button
            type="button"
            className="btn-secondary"
            onClick={prevStep}
          >
            <span className="btn-icon">←</span>
            Back
          </button>
          <button
            type="button"
            className="btn-primary"
            onClick={handleSubmit}
          >
            Continue to Payment
            <span className="btn-icon">→</span>
          </button>
        </div>
      </div>
    </div>
  );
};

export default Step5Review;
